module.exports = __webpack_public_path__ + "img/le-logo-wide2.62b03d48.svg";